import { m } from "@plannello/i18n/messages";
import { useRouter } from "@tanstack/react-router";
import { InlineError } from "@/components/ui";
import { ApiError } from "@/lib/api";

/** Shared errorComponent for the root and authenticated layouts: inline message with retry. */
export function RouteError({ error, reset }: { error: unknown; reset: () => void }) {
  const router = useRouter();
  const network = error instanceof ApiError && (error.isNetwork || error.isServer);
  return (
    <main id="main" tabIndex={-1} className="mx-auto flex min-h-dvh max-w-md flex-col justify-center gap-4 p-6">
      <h1 className="text-lg font-semibold">{m.error_page_title()}</h1>
      <InlineError
        message={network ? m.error_network() : m.error_generic()}
        onRetry={() => {
          reset();
          void router.invalidate();
        }}
      />
    </main>
  );
}
